module.exports = __webpack_public_path__ + "img/clients-bg-right.f1d94adc.png";